"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AnnotationRenderer2 = _interopRequireDefault(require("../AnnotationRenderer"));

var _AnnotationSchemaV = _interopRequireDefault(require("./AnnotationSchemaV3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var AnnotationRendererV3 = /*#__PURE__*/function (_AnnotationRenderer) {
  _inherits(AnnotationRendererV3, _AnnotationRenderer);

  var _super = _createSuper(AnnotationRendererV3);

  function AnnotationRendererV3() {
    _classCallCheck(this, AnnotationRendererV3);

    return _super.apply(this, arguments);
  }

  _createClass(AnnotationRendererV3, [{
    key: "render",
    value: function render() {
      var context = this.context;
      var height = this.height;
      var width = this.width;
      var annotations = this.annotations;
      var schema = _AnnotationSchemaV["default"];
      this.clear();
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.miterLimit = 10;
      annotations.forEach(function (annotation) {
        if (annotation) {
          if ([schema.TYPE_PEN, schema.TYPE_HIGHLIGHTER].indexOf(annotation.type) > -1) {
            renderPointsAnnotation(annotation);
          } else if (annotation.type === schema.TYPE_TEXT) {
            renderTextAnnotation(annotation);
          }
        }
      });

      function renderPointsAnnotation(annotation) {
        var points = annotation.points;
        var pointCount = points.length; // Draw lines between points, no bezier

        if (pointCount > 0) {
          var point = points[0];
          var x = point[0] * width;
          var y = point[1] * height;
          context.beginPath();
          context.moveTo(x, y); // Make sure we can draw dots from single lines

          context.lineTo(x + 0.01, y);

          for (var i = 1; i < pointCount; i++) {
            point = points[i];
            x = point[0] * width;
            y = point[1] * height;
            context.lineTo(x, y);
          }

          context.lineWidth = parseFloat(annotation.size) * width;
          context.strokeStyle = '#' + annotation.color;
          context.globalAlpha = schema.TYPE_COLOR_ALPHA[annotation.type];
          context.stroke();
        }
      }

      function renderTextAnnotation(annotation) {
        var points = annotation.points;
        var pointCount = points.length;

        if (pointCount !== 2) {
          throw new Error('Text annotation expects 2 points');
        }

        var x1 = points[0][0] * width;
        var y1 = points[0][1] * height;
        var x2 = points[1][0] * width;
        var maxWidth = x2 - x1;
        var size = annotation.size * width;
        var offsetTop = y1;
        var text;
        var textHeight = 0;
        var line;
        /**
         * Get the next line of text
         * Split on new-line first, words afterwards, and then characters
         */

        function getNextLine() {
          text = text.trim();
          var lines = text.split("\n");
          var line = lines[0];
          var lineWidth = context.measureText(line).width;

          if (lineWidth > maxWidth) {
            while (line.indexOf(' ') > -1 && lineWidth > maxWidth) {
              line = line.substr(0, line.lastIndexOf(' '));
              lineWidth = context.measureText(line).width;
            }

            while (lineWidth > maxWidth && line.length > 1) {
              line = line.substr(0, line.length - 1);
              lineWidth = context.measureText(line).width;
            } // update remaining text


            lines[0] = lines[0].substr(line.length);
            text = lines.join("\n");
          } else {
            // update remaining text
            lines.shift();
            text = lines.join("\n");
          }

          return line;
        }

        text = annotation.text;
        line = getNextLine(); // Calculate box height

        while (typeof line === 'string' && line.length > 0) {
          textHeight += schema.TEXT_LINE_HEIGHT * size;
          line = getNextLine();
        }

        context.fillStyle = 'rgba(255, 255, 255, 0.25)';
        context.fillRect(x1, y1, x2 - x1, textHeight);
        context.globalAlpha = 1;
        context.font = size + 'px ' + schema.TEXT_FONT_FAMILY.split(',')[0].trim();
        context.fillStyle = '#' + annotation.color;
        context.fontFamily = schema.TEXT_FONT_FAMILY;
        text = annotation.text;
        line = getNextLine();

        while (typeof line === 'string' && line.length > 0) {
          context.fillText(line, x1, offsetTop + size);
          offsetTop += schema.TEXT_LINE_HEIGHT * size;
          line = getNextLine();
        }
      }
    }
  }]);

  return AnnotationRendererV3;
}(_AnnotationRenderer2["default"]);

var _default = AnnotationRendererV3;
exports["default"] = _default;